(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["au-split-feature"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const items = new Set();
    let ticking = false;
    const update = () => {
      ticking = false;
      const vh = window.innerHeight;
      items.forEach((el) => {
        const r = el.getBoundingClientRect();
        const mid = r.top + r.height / 2 - vh / 2;
        const shift = Math.max(-1, Math.min(1, mid / vh)) * r.height * -0.05;
        el.style.setProperty('--au-sf-shift', shift.toFixed(1) + 'px');
      });
    };
    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => (e.isIntersecting ? items.add(e.target) : items.delete(e.target)));
      onScroll();
    });
    const watch = () => document.querySelectorAll('[data-au-parallax]:not([data-au-plx-on])').forEach((el) => { el.dataset.auPlxOn = ''; io.observe(el); });
    watch();
    document.addEventListener('shopify:section:load', watch);
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
